/* eslint-disable i18next/no-literal-string */
'use client';

import { useEffect } from 'react';

import { trackError } from '@sola/tracking/components/datalayer.tsx';

const GlobalError = ({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) => {
  useEffect(() => {
    console.error(error);
    trackError(error.digest || error.message);
  }, [error]);

  return (
    <html lang="en">
      <body>
        <h2>Something went wrong!</h2>
        <button type="button" onClick={() => reset()}>
          Try again
        </button>
      </body>
    </html>
  );
};

export default GlobalError;
